import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    IconButton,
    Box,
} from "@mui/material";
import T from "prop-types";
import { CloseOutlined } from "@ant-design/icons";
import { styled } from "@mui/material/styles";

const Transition = React.forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
));

const StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiPaper-root": {
        borderRadius: "8px",
    },
    "& .MuiDialogActions-root": {
        gap: theme.spacing(1),
        marginLeft: "0 !important",
        padding: "0px 24px 48px 24px",
    },
    "& .MuiDialogTitle-root.MuiTypography-root": {
        fontSize: 16,
        fontWeight: "bold",
    },
}));

const FormModal = ({
    isOpen = false,
    renderActions,
    closeIcon = false,
    onClose,
    title,
    children,
    className,
    maxWidth = "md",
    ...props
}) => (
    <StyledDialog
        open={isOpen}
        transition={Transition}
        keepMounted
        className={`confirmation-dialog ${className}`}
        fullWidth={true}
        maxWidth={maxWidth}
        onClose={onClose}
        {...props}
    >
        <DialogTitle
            align="left"
            sx={{ borderBottom: "1px solid #e6ebf1", height: "52px" }}
        >
            <>
                <Box
                    sx={{
                        marginLeft: "32px",
                        fontWeight: 400,
                        fontSize: "14px",
                    }}
                >
                    {title}
                </Box>
                {closeIcon ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            left: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseOutlined />
                    </IconButton>
                ) : null}
            </>
        </DialogTitle>
        <DialogContent align="center">{children}</DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
            {renderActions()}
        </DialogActions>
    </StyledDialog>
);

FormModal.propTypes = {
    renderActions: T.func.isRequired,
    isOpen: T.bool.isRequired,
    title: T.string.isRequired,
    onClose: T.func.isRequired,
    children: T.any,
    closeIcon: T.bool,
    className: T.string,
    maxWidth: T.string,
};

export default FormModal;
